// Generated by GitHub Copilot
/**
 * Shared constants for impact reporting feature
 */

/**
 * Status color mappings for impact status badges
 * Used across ImpactRecordCard and ImpactTableRow components
 */
export const STATUS_COLORS = {
  active: { bg: "#fee2e2", text: "#dc2626" },
  resolved: { bg: "#d1fae5", text: "#059669" },
  // Legacy status colors for backward compatibility
  critical: { bg: "#fee2e2", text: "#dc2626" },
  degraded: { bg: "#fef3c7", text: "#d97706" },
  recovered: { bg: "#d1fae5", text: "#059669" },
};

/**
 * Get status colors for a given status
 * @param {string} status - Impact status
 * @returns {object} - Object with bg and text color properties
 */
export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || { bg: "#f3f4f6", text: "#6b7280" };
};

/**
 * Color palette for user's own impacts (Tailwind CSS blue shades)
 * Used to visually distinguish impacts created by the current user
 */
export const MY_IMPACT_COLORS = {
  bg: "#dbeafe",       // Light blue background
  bgHover: "#bfdbfe",  // Slightly darker blue on hover
  border: "#3b82f6",   // Blue accent border
  text: "#1e40af",     // Dark blue text (for potential badge use)
};
